import { FormikHelpers } from "formik";
import CustomForm from "../common/Form";
import React, { useCallback, useEffect, useState } from "react";
import { CardItem } from "../common/Card/Card";
import { Card } from "react-bootstrap";
import { CardBodyHorizontal } from "../common/Card/CardBody";
import Pagination from "../common/Pagination";
import { useSearchParams } from "react-router-dom";
import { apiGet } from "../services/Api";
import { SearchResponse } from "../helpers/interfaces/search";
import { ArticleType } from "../helpers/interfaces/news";
import { ITeam } from "../helpers/interfaces/matchData";
import CssLoader from '../components/cssloader/CssLoader';
import './Ricerca.css';
import Advertising from "../common/Advertising";
import PageMeta from "../components/PageMeta";

export default function RicercaPage() {
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [searchParams, setSearchParams] = useSearchParams();
    const [searchCards, setSearchCards] = useState<CardItem[]>([]);
    const [isMount, setIsMount] = useState<boolean>(false);
    const [currentPage, setCurrentPage] = useState<number>(1);
    const pageLimit = 16;
    const pageNeighbours = 5;

    const searchAPI = useCallback(async (keyword: string) => {
        setIsLoading(true);

        await apiGet<SearchResponse, any>('?op=ricerca&keyword=' + encodeURI(keyword)).then((
            searchResults: SearchResponse
        )=> {
            let searchCards: CardItem[] = [];

            searchCards = searchCards.concat(
                createArticlesCards(searchResults.articoli)
            );
            searchCards = searchCards.concat(
                createTeamsCards(searchResults.squadre)
            );

            setSearchCards(searchCards);
        }).finally(() => {
            setIsLoading(false);
        });
    }, []);

    const createArticlesCards = (items: ArticleType[]): CardItem[] => {
        return items.map((item: ArticleType, index: number) => {
            return {
                id: item.id,
                header: index === 0 ? <h4>Articoli</h4> : undefined,
                title: item.titolo,
                subtitle: <>{item.strDataPubblicazione} - <span className="author-name">{item.nomeAutore}</span></>,
                content: item.articoloBreve,
                image: item.img1,
                link: '/articolo/' + item.id,
                linkTitle: item.titolo
            }
        })
    }

    const createTeamsCards = (items: ITeam[]): CardItem[] => {
        return items.map((item: ITeam, index: number) => {
            return {
                id: item.id,
                header: index === 0 ? <h4>Squadre</h4> : undefined,
                title: item.nome,
                content: '',
                image: item?.img || 'https://www.calcioa5live.com/img/squadre/VARIE.png',
                link: '/societa/' + item.id,
                linkTitle: item.nome
            }
        })
    }

    useEffect(() => {
        if (!isMount || true) {
            (async() => {
                let keyword = searchParams.get('q');
                if (keyword) await searchAPI(keyword);
                setIsMount(true);
            })()
        }
    }, [isMount, searchParams, searchAPI])

    const paginationCards = [...searchCards].splice(
        ((currentPage - 1) * pageLimit),
        pageLimit
    );

    const SearchCards = (props: { id: string, cards: CardItem[] }) => {
        let count = 0;

        return <>
            {props.cards.map((card, index) => {
                count++
                return <React.Fragment key={index}>
                    <Card id={`${props.id}_${index}`}>
                        <Card.Body className="px-2">
                            {card.header ? card.header : undefined}
                            {CardBodyHorizontal(card)}
                        </Card.Body>
                    </Card>
                    {count % 4 === 0 && count < props.cards.length ? <>
                        {count === 4 && <Advertising code="banner-cat4" as="div" />}
                        {count === 8 && <Advertising code="banner-cat5" as="div" />}
                        {count === 12 && <Advertising code="banner-cat6" as="div" />}
                    </> : <></>}
                </React.Fragment>
            })}
        </>
    }

    return <>
        <PageMeta
            title={`Ricerca ${searchParams.get('q')} - Calcio a 5 Live`}
            description=""
            image=""
            url={document.location.href}
            type=""
        />
        <h1>Risultati della ricerca</h1>

        <div className="search-container">
            <CustomForm
                id="search-form"
                formFields={[
                    {
                        id: "keyword",
                        name: "keyword",
                        type: "string",
                        placeholder: 'Inserisci un parametro di ricerca per iniziare',
                    }
                ]}
                initialValues={{
                    keyword: searchParams.get('q')?.toString()
                }}
                onSubmit={(
                    values: { keyword: string },
                    formikHelpers: FormikHelpers<any>
                ) => {
                    formikHelpers.setFieldValue('keyword', values.keyword)
                    setSearchParams({q: values.keyword})
                    searchAPI(values.keyword);
                }}
                submitText={<i className="fa fa-search" />}
            />
        </div>
        <hr />
        <div className="search-container">
            <div id="search-info">
                <h3 className="d-inline">Hai cercato:</h3>{' '}
                <span id="search-keyword">{searchParams.get('q')}</span>
            </div>

            <div id="search-results">
                <SearchCards id="search-results" cards={paginationCards} />
            </div>

            <div className="py-3">
                <Pagination
                    totalRecords={searchCards.length}
                    pageLimit={pageLimit}
                    pageNeighbours={pageNeighbours}
                    currentPage={currentPage}
                    onPageChanged={(value: any) => { setCurrentPage(value) }}
                />
            </div>
        </div>

        <CssLoader active={isLoading} text="Ricerca dei risultati in corso..." />
    </>
}